import { render, staticRenderFns } from "./ProtocoloHistory.vue?vue&type=template&id=f384a7a8&"
import script from "./ProtocoloHistory.vue?vue&type=script&lang=js&"
export * from "./ProtocoloHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports